import {assertType} from "../base/utils";
import {Currency} from "./Currency";
import { IdentityRef, Ref } from './Ref';

class Amount {
    private _currency : Ref<Currency>;
    private _value : number;

    constructor(value : number, currency : Ref<Currency>) {
        assertType(value, "value", Number);
        assertType(currency, "currency", Ref);
        this._value = value;
        this._currency = currency;
    }

    get value() { return this._value; }
    get currency() { return this._currency; }

    static identityValue = new Amount(0, Currency.identityRef);
    static identity() {
        return Amount.identityValue;
    }

    add(amount : Amount) {
        assertType(amount, "amount", Amount);

        if (this.currency !== Currency.identityRef && amount.currency.uuid !== this.currency.uuid) {
            throw Error("Cannot be added");
        }
        return new Amount(this.value + amount.value, amount.currency);
    }
    
    string() {
        if (!this._currency) {
            return this._value;
        }
        return this._value + " " + this._currency.obj().symbol;
    }

    toJson() : AmountJSON {
        return {
            value: this._value,
            currency: this._currency ? this._currency.uuid : ""
        }
    }
    
    static add(amount1 : Amount, amount2: Amount) {
        return amount1.add(amount2);
    }

    static fromJson(amount:AmountJSON) {
        const currency = Currency.createRef(amount.currency);
        const value = amount.value;
        return new Amount(value, currency);
    }
}

interface AmountJSON {
    value:number,
    currency: string
}

export { Amount, AmountJSON };